<template>
  <div class="header-container">
    <div class="router-view">
      <el-breadcrumb separator-class="el-icon-arrow-right" separator=">">
        <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">
          <span
            :class="{ menuNow: index === $route.meta.length - 1, canClick: item.url }"
            class="bread"
            @click="changeRouter(item.url, index)"
          >
            {{ item.name }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="admin-right">
      <img class="admin-head" width="32px" src="../assets/images/ic_login_account.png" />
      <span class="user-name">你好 {{ nickname }}！</span>
      <span class="logout" @click="onLogoutClick">注销</span>
    </div>
  </div>
</template>

<script>
import Utils from "../jslibs/utils";
import { mapState, mapMutations } from "vuex";

// import { editAuthUser, getAuthListDetail } from '@/api/auth'
// import { getSetting, changeSetting } from '@/api/common'

export default {
  components: {},
  data() {
    return {
      nickname: Utils.getCookie("X-Access-Name"),
      dialogVisible: false,
      form: {},
      formLabelWidth: "120px",
      needQuery: [], // 需要参数的第二个面包屑
      dialogTitle: "编辑管理员",
      dialogType: "",
      isMessage: false,
      isWallet: false,
      settingInfo: {},
    };
  },
  computed: {
    ...mapState(["loginData", "id"]),
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapMutations(["updateLoginData", "update_id"]),
    changeRouter(url, index) {
      if (url) {
        const meta = this.$route.meta;
        // index length
        // 1 3  2 4  3 5
        // 1 4 1 5  2 5
        // index + 1 - length
        this.$router.go(index + 1 - meta.length);
        // //不需要传参数
        // if ((meta.length <= 3 && !this.needQuery.includes(meta[index].name)) || index < 2) {
        //   this.$router.push({ path: url });
        // } else {
        //   //需要传参去页面中传参跳转
        //   this.bus.$emit('navigate', index)
        // }
      }
    },
    onChangePasswordClick() {
      console.log("change");
    },
    onLogoutClick() {
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="less">
@import "~@/assets/styles/variables.less";

.header-container {
  padding: 0 27px 0 30px;
  height: 63px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  margin: 0;
  width: calc(100vw - 200px);
  width: -webkit-calc(100vw - 200px);
  width: -moz-calc(100vw - 300px);
  position: fixed;
  border-bottom: 1px solid #e5e5e5;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 2;
  .search-row {
    width: 100%;
  }
  .router-view {
    /deep/.el-breadcrumb {
      line-height: 20px;
    }
    .menuNow {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
    .canClick {
      cursor: pointer;
    }
    .canClick:hover {
      color: @main-color;
    }
    .bread {
      font-size: 14px;
      color: #333;
    }
  }
  .filter-view {
    display: flex;
    padding-right: 25px;
    align-items: center;
    .type {
      margin: 0 10px;
      color: #223040;
      background: rgba(0, 0, 0, 0);
      margin: 0 15px;
    }
  }
  .admin-right {
    height: 100%;
    display: flex;
    align-items: center;
    .admin-head {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 12px;
    }
    .user-name {
      font-size: 14px;
    }
    .logout {
      font-size: 12px;
      cursor: pointer;
    }
  }
}
.dk-icon-back {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin: 12px 12px 0 0;
}

.top-search-input {
  width: 220px;
  margin: 0 10px;
  .search-icon {
    width: 36px !important;
    height: 36px !important;
    padding: 10px 11px !important;
  }
  .search-row {
    margin-bottom: 30px;
  }
}
.dialog-body-wrap {
  .item {
    margin-bottom: 20px;
  }
}
</style>
